<template>
  <section class="tile licenses--create" id="license-create">
    <h3 class="content__heading">License Creator</h3>
    <div v-if="getActiveWebsite" class="licenses--create-active">
      <div class="licenses--create-upper mb-15">
        <span class="text__bold site">{{ getActiveWebsite }}</span>
        <span class="text__bold spacer">|</span>
        <label for="state" class="text__bold text__center state">
          State:
          <select v-model="form.state" name="state" class="ml-10">
            <option value="Alabama">Alabama</option>
            <option value="Alaska">Alaska</option>
            <option value="Arizona">Arizona</option>
            <option value="Arkansas">Arkansas</option>
            <option value="California">California</option>
            <option value="Colorado">Colorado</option>
            <option value="Connecticut">Connecticut</option>
            <option value="Delaware">Delaware</option>
            <option value="District Of Columbia">District Of Columbia</option>
            <option value="Florida">Florida</option>
            <option value="Georgia">Georgia</option>
            <option value="Hawaii">Hawaii</option>
            <option value="Idaho">Idaho</option>
            <option value="Illinois">Illinois</option>
            <option value="Indiana">Indiana</option>
            <option value="Iowa">Iowa</option>
            <option value="Kansas">Kansas</option>
            <option value="Kentucky">Kentucky</option>
            <option value="Louisiana">Louisiana</option>
            <option value="Maine">Maine</option>
            <option value="Maryland">Maryland</option>
            <option value="Massachusetts">Massachusetts</option>
            <option value="Michigan">Michigan</option>
            <option value="Minnesota">Minnesota</option>
            <option value="Mississippi">Mississippi</option>
            <option value="Missouri">Missouri</option>
            <option value="Montana">Montana</option>
            <option value="Nebraska">Nebraska</option>
            <option value="Nevada">Nevada</option>
            <option value="New Hampshire">New Hampshire</option>
            <option value="New Jersey">New Jersey</option>
            <option value="New Mexico">New Mexico</option>
            <option value="New York">New York</option>
            <option value="North Carolina">North Carolina</option>
            <option value="North Dakota">North Dakota</option>
            <option value="Ohio">Ohio</option>
            <option value="Oklahoma">Oklahoma</option>
            <option value="Oregon">Oregon</option>
            <option value="Pennsylvania">Pennsylvania</option>
            <option value="Rhode Island">Rhode Island</option>
            <option value="South Carolina">South Carolina</option>
            <option value="South Dakota">South Dakota</option>
            <option value="Tennessee">Tennessee</option>
            <option value="Texas">Texas</option>
            <option value="Utah">Utah</option>
            <option value="Vermont">Vermont</option>
            <option value="Virginia">Virginia</option>
            <option value="Washington">Washington</option>
            <option value="West Virginia">West Virginia</option>
            <option value="Wisconsin">Wisconsin</option>
            <option value="Wyoming">Wyoming</option>
          </select>
        </label>
      </div>
      <Editor :api-key="apiKey" :init="config" v-model="form.content" />
      <div class="edit--buttons flex__right mt-15">
        <a class="btn btn__small btn__red mr-10" @click="cancelCreate">Cancel</a>
        <button class="btn btn__small btn__green ml-10" @click="createLicense">Submit</button>
      </div>
    </div>
    <div v-else class="licenses--inactive">
      <p>Click the green "plus" on the website you would like to update</p>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import editorConfig from "../../../plugins/tinymce";
export default {
  data() {
    return {
      form: {
        state: null,
        content: null
      }
    };
  },
  computed: {
    ...mapGetters(["getActiveWebsite"]),
    apiKey() {
      return editorConfig.apiKey;
    },
    config() {
      return editorConfig.config;
    }
  },
  methods: {
    ...mapActions(["startCreateLicense", "startSetActiveWebsite"]),
    async createLicense() {
      if (!this.form.state) {
        this.flash("You must select a state for this license", "error");
        return null;
      }
      if (!this.form.content || this.form.content.length === 0) {
        this.flash("You must enter some licensing information", "error");
        return null;
      }
      const form = {
        ...this.form,
        website: this.getActiveWebsite
      };
      try {
        await this.startCreateLicense(form);
        await this.startSetActiveWebsite(null);
        this.form.state = null;
        this.form.content = null;
      } catch (err) {
        return null;
      }
    },
    cancelCreate() {
      this.form.state = null;
      this.form.content = null;
      this.startSetActiveWebsite(null);
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
</style>